import * as React from "react"
import { AlertTriangle } from "lucide-react"
import { cn } from "../../lib/utils"
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "./tooltip"

const Input = React.forwardRef(({ className, type, onChange, onKeyDown, onKeyUp, onBlur, min, max, ...props }, ref) => {
  const isDate = type === "date";
  const isPassword = type === "password";
  const [capsLockOn, setCapsLockOn] = React.useState(false);

  const handleChange = (e) => {
    if (isDate) {
      const v = e.target.value;
      // Bloqueia ano com mais de 4 dígitos durante a digitação
      if (v && v.split("-")[0].length > 4) return;
    }
    onChange?.(e);
  };

  const checkCapsLock = (e) => {
    if (isPassword && typeof e.getModifierState === "function") {
      setCapsLockOn(e.getModifierState("CapsLock"));
    }
  };

  const handleKeyDown = (e) => {
    checkCapsLock(e);
    onKeyDown?.(e);
  };

  const handleKeyUp = (e) => {
    checkCapsLock(e);
    onKeyUp?.(e);
  };

  const handleBlur = (e) => {
    if (isPassword) setCapsLockOn(false);
    onBlur?.(e);
  };

  const inputEl = (
    <input
      type={type}
      min={isDate ? (min ?? "1950-01-01") : min}
      max={isDate ? (max ?? "2100-12-31") : max}
      onChange={handleChange}
      onKeyDown={isPassword ? handleKeyDown : onKeyDown}
      onKeyUp={isPassword ? handleKeyUp : onKeyUp}
      onBlur={isPassword ? handleBlur : onBlur}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );

  if (!isPassword) return inputEl;

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip open={capsLockOn}>
        <TooltipTrigger asChild>{inputEl}</TooltipTrigger>
        <TooltipContent
          side="top"
          className="bg-amber-500 text-white border-none flex items-center gap-1.5 z-[100]"
        >
          <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
          Caps Lock ativado
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
})
Input.displayName = "Input"
export { Input }